import { Falcon } from 'modules/macro';
import { StateComponent } from './StateComponent';
export function DialogError(props) {
    return <StateComponent icon={<Falcon icon="exclamation-triangle" $size={32}/>} {...props}/>;
}
